import axios from "axios";
import {
    IP
} from "./config";
// 查询
export async function selectApply() {
    var resp = await axios.post(`${IP}/input/selectApply`, {});
    return resp.data.data;
}


//修改账号
export async function updateApply(form) {
    var resp = await axios.post(`${IP}/input/updateApply`, {
        id:form.id,
        role_id: form.role_id,
        sup_username: form.sup_username,
        sup_password: form.sup_password,
        supplier_phone: form.supplier_phone,
        message: form.message
    });
    return resp;
}

// 删除用户
export async function deleteApply(id) {
    var resp = await axios.post(`${IP}/input/deleteApply`, {
        id
    });
    return resp;
}


// 查询
export async function selectNeed() {
    var resp = await axios.post(`${IP}/input/selectNeed`, {});
    return resp.data.data;
}


//修改账号
export async function updateNeed(form) {
    var resp = await axios.post(`${IP}/input/updateNeed`, {
        id:form.id,
        role_id: form.role_id,
        sup_username: form.sup_username,
        sup_password: form.sup_password,
        supplier_phone: form.supplier_phone,
        message: form.message
    });
    return resp;
}

// 删除用户
export async function deleteNeed(id) {
    var resp = await axios.post(`${IP}/input/deleteNeed`, {
        id
    });
    return resp;
}